import useTabSwipe from '../../components/common/useTabSwipe';
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import PageLayout from '../../components/layout/PageLayout';
import Chevron from '../../components/content/Chevron';
import '../../styles/AppParity.css';
import './Browse.css';
import './BrowseAppUi.css';
import AppUiScope from '../../app-ui/AppUiScope';
const destinations = [
  ['albums', '/albums'],
  ['reviews', '/reviews'],
  ['playlists', '/lists'],
];
// Keep Explore's destinations in one stable order on tablet and desktop.
export function BrowseNavigation() {
  const { t, locale } = useWebLocale();
  return (
    <nav
      className="pp-explore-subnav"
      id="pp-explore-menu"
      aria-label={locale === 'en' ? 'Explore categories' : '탐색 카테고리'}
    >
      {destinations.map(([key, to]) => (
        <NavLink key={key} to={to} end>
          {t(key)}
        </NavLink>
      ))}
    </nav>
  );
}
export function BrowseHeading({ active, mobile = false }) {
  const { t, locale } = useWebLocale();
  return (
    <div lang={locale} className={`pp-browse-heading${mobile ? ' pp-browse-mobile-heading' : ''}`}>
      <Link
        to="/explore"
        className="pp-browse-back"
        aria-label={locale === 'en' ? 'Back to Explore' : '탐색으로 돌아가기'}
      >
        <Chevron direction="left" />
      </Link>
      <h1>{t(active)}</h1>
      <nav aria-label={t('explore')}>
        {destinations
          .filter(([key]) => key !== active)
          .map(([key, to]) => (
            <Link key={key} to={to}>
              {t(key)}
              <Chevron />
            </Link>
          ))}
      </nav>
    </div>
  );
}
export default function BrowseShell({ active, children, swipe }) {
  const gestures = useTabSwipe(swipe || { enabled: false, values: [] });
  const Root = AppUiScope;
  return (
    <PageLayout paddingTop={{ xs: '8px', md: '12px' }}>
      <Root
        {...(Root === AppUiScope ? { surface: 'lists' } : {})}
        {...gestures}
        className={`pp-parity pp-browse pp-browse-${active}`}
      >
        <BrowseHeading active={active} />
        {children}
      </Root>
    </PageLayout>
  );
}
export function BrowseSegments({ options, value, onChange }) {
  return (
    <div className="pp-browse-segments" role="tablist">
      {options.map(([key, label]) => (
        <button
          type="button"
          key={key}
          role="tab"
          aria-selected={value === key}
          tabIndex={value === key ? 0 : -1}
          onKeyDown={(event) => {
            const index = options.findIndex(([id]) => id === key);
            const next =
              event.key === 'ArrowRight'
                ? (index + 1) % options.length
                : event.key === 'ArrowLeft'
                  ? (index + options.length - 1) % options.length
                  : event.key === 'Home'
                    ? 0
                    : event.key === 'End'
                      ? options.length - 1
                      : null;
            if (next === null) return;
            event.preventDefault();
            onChange(options[next][0]);
            event.currentTarget.parentElement.children[next].focus();
          }}
          onClick={() => onChange(key)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
